import React from 'react'
import { useTranslation } from 'react-i18next'

import FormTextBoxCommon, { TextBoxProps } from '~/components/molecules/form/textbox/FormTextBoxCommon'
import SupplementText from '~/components/atoms/text/SupplementText'
import FormInputNote from '~/components/wrapper/form/FormInputNote'
import FormInputDescription from '~/components/wrapper/form/FormInputDescription'

interface Props extends TextBoxProps {
  isSetting?: boolean
}

const FormPassword = (props: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <FormTextBoxCommon
        {
          ...{
            type: 'password',
            ...props
          }
        }
      />
      {props.isSetting &&
        <FormInputDescription>
          {t('placeholder.password')}
        </FormInputDescription>
      }
    </>
  )
}

export default FormPassword